/**
 * File: createProgramme.js
 * Project: educore
 * Created Date: 2019-03-22
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class CreateProgrammeController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state, MEDICALCONSTANT, authService) {

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        $scope.stateId = "createProgramme"
        let schoolId = localStorageService.get('school_id')
        let academicYear = localStorageService.get('academic_year')
        let userId = localStorageService.get('user_id')
        $scope.doctorProgram = {}
        $scope.selectUsers = false

        //Boolean - To show loading
        $scope.isFacultyLoaded = true
        $scope.findTime = () => {
            console.log('111')
        }
        $scope.reqObj = {}
        $scope.personList = []
        $scope.isSelected = false
        $scope.clearParentFields = function() {
            $scope.userNamesEndorsed = []
            $scope.userEndorsedAcademic = []
            $scope.userNotEndorsedAcademic = []
            $scope.userNamesNotEndorsed = []
        }

        function clearFields() {
            $scope.pager = {};
            $scope.setPage = setPage;
            $scope.pageIndex = [];
        }

        $scope.searchValuesBasedOnFilter = function() {
            if (this.filterObj === undefined || this.filterObj.role_id === undefined) {
                toastr.error('Please Select the Role')
                return false;
            } else if (this.filterObj === undefined || this.filterObj['session'] === undefined) {
                toastr.error('Please Select the Session')
                return false;
            } else if (this.filterObj === undefined || this.filterObj['curriculum'] === undefined) {
                toastr.error('Please Select the Curriculum')
                return false;
            } else if (this.filterObj === undefined || this.filterObj['xclass'] === undefined || this.filterObj['xclass'].length <= 0) {
                toastr.error('Please Select the Class')
                return false;
            } else if (this.filterObj === undefined || this.filterObj['batch'] === undefined || this.filterObj['batch'].length <= 0) {
                toastr.error('Please Select the Batch')
                return false;
            }

            //setFilterValue(this.filterObj)

            $scope.reqObj.roleId = this.filterObj.role_id
            $scope.reqObj.sessionId = this.filterObj.session
            $scope.reqObj.curriculumId = this.filterObj.curriculum
            $scope.reqObj.classId = this.filterObj.xclass
            $scope.reqObj.batchId = this.filterObj.batch
            $scope.reqObj["school_id"] = localStorageService.get('school_id')
            $scope.getUsersLists();
        }
        $scope.getUsersLists = () => {
            $scope.loading = true;
            authService.callAPI(MEDICALCONSTANT.API_POST_GET_ALL_USERS, "POST", $scope.reqObj, (response) => {
                if (response.result && response.result.data) {
                    $scope.userNames = response.result.data.users
                    $scope.loading = false;
                    $scope.UniqueNoText = ($scope.reqObj.roleId === "student") ? "Admission No" : "Employee No"
                    _.defer(function() {
                        $scope.$apply();
                    });
                } else {
                    $scope.loading = false;
                    toastr.error('Server Interpreted.Please try after some time.')
                }
            })
        }
        $scope.toggleUnSelectAllUser = () => {
            _.each($scope.userNames, function(data) {
                data.is_selected = $scope.isSelected ? false : true
            })
            console.log($scope.userNames)
        }


        $scope.saveProgram = (programme, resultData) => {
            $scope.errors = {}
            let errorCount = 0
            let datePgm = programme.date
            let dateRedef
            let timeRedef
            if (datePgm) {
                dateRedef = new Date(datePgm.getFullYear() + '-' + (datePgm.getMonth() + 1) + '-' + datePgm.getDate() + ' ' + "00" + ":" + "00" + ": 01")
                timeRedef = new Date(datePgm.getFullYear() + '-' + (datePgm.getMonth() + 1) + '-' + datePgm.getDate() + ' ' + datePgm.getHours() + ":" + datePgm.getMinutes() + ": 01")
            }

            let userIdArray = []
            _.each($scope.userNames, function(eachUser) {
                if (eachUser.is_selected === true)
                    userIdArray.push(eachUser)
            })
            if (userIdArray.length === 0) {
                $scope.errors['setOfClasseseror'] = "Please select attendees"
                return false
            }
            let pgmData = {
                date: (programme.date) ? dateRedef : null,
                organiser: (programme.organiser) ? programme.organiser : null,
                time: timeRedef ? timeRedef : dateRedef,
                topic: (programme.topic) ? programme.topic : null,
                user_list: userIdArray,
                school_id: schoolId,
                academic_year: academicYear,
                user_id:userId
            }
            console.log(pgmData)
            if (errorCount === 0) {
                $scope.errors = {}
                $scope.on_progress = true
                $scope.returnValue = false
                $scope.loading = true
                    /*Meteor.call("announceProgram", objToPass, userIdArray, schoolId, function(error, result) {
                        if (error) {
                            if (error.error) {
                                $scope.loading = false
                                toastr.error("Server Interpreted.Please try after some time.")
                            }
                        } else {
                            $scope.on_progress = false
                            $scope.loading = false
                            toastr.success("Programme created successfully!")
                            $state.go("programConsole")
                        }
                    });*/
                authService.callAPI(MEDICALCONSTANT.API_SAVE_PROGRAMME, "POST", pgmData, (response) => {
                    if (response.result && response.result.data) {
                        toastr.success('Programme created successfully')
                        $state.go("programmeConsole")
                        _.defer(function() {
                            $scope.$apply();
                        });
                    } else {
                        $scope.loading = false;
                        toastr.error('Server Interpreted.Please try after some time.')
                    }
                })
            }
        }
    }
}
export default CreateProgrammeController



// WEBPACK FOOTER //
// ./src/app/medical/controllers/medicalProgramme/createProgramme.js